import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {Div, DivLarge} from 'components/primitives/body';


export class SignupInstructions extends React.Component {
    render() {
        return (
            <DescriptionWrapper>
                <ParagraphWrapper>
                    <DescriptionTitle>
                        <FormattedMessage {...messages.createAccount}/>
                    </DescriptionTitle>
                    <DetailsWrapper>
                        <FormattedMessage {...messages.fastAndSecure}/>
                    </DetailsWrapper>
                </ParagraphWrapper>
                <ParagraphWrapper>
                    <AbstractWrapper>
                        <FormattedMessage {...messages.justTheBasics}/>
                    </AbstractWrapper>
                    <DetailsWrapper>
                        <FormattedMessage {...messages.tellUsAboutYou}/>
                    </DetailsWrapper>
                </ParagraphWrapper>
                <ParagraphWrapper>
                    <AbstractWrapper>
                        <FormattedMessage {...messages.safeAndSecure}/>
                    </AbstractWrapper>
                    <DetailsWrapper>
                        <FormattedMessage {...messages.needInfo}/>
                    </DetailsWrapper>
                </ParagraphWrapper>
            </DescriptionWrapper>
        );
    }
}

const DescriptionWrapper = styled.div`
  margin-top: calc(20vh + 40px);
  min-height: 100%;
  color: white;
  font-family: 'Roboto Mono', monospace;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  @media only screen and (max-width: 768px) {
    margin-top: 48px;
  }
`;

const DescriptionTitle = styled.div`
  padding-bottom: 12px;
  font-size: 20px;
`;

const ParagraphWrapper = styled.div`
  padding-bottom: 24px;
`;

const AbstractWrapper = styled(DivLarge)`
  color: inherit;
  padding-bottom: 8px;
  font-weight: 500;
`;

const DetailsWrapper = styled(Div)`
  color: inherit;
  opacity: 0.76;
`;
